import React, { useState, useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { IIdTokenClaims } from '../util/DataModelInterface';
import { Navigate } from 'react-router-dom';

/**
 * The `MsalAuthenticationTemplate` component will render its children if a user is authenticated
 * or attempt to sign a user in. Just provide it with the interaction type you would like to use
 * (redirect or popup) and optionally a request object to be passed to the login API, a component to display while
 * authentication is in progress or a component to display if an error occurs. For more, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
 */
export const RouteGuard = ({ ...props }) => {
    const { instance } = useMsal();
    const [isAuthorized, setIsAuthorized] = useState(false);

    const currentAccount = instance.getActiveAccount();

    useEffect(() => {
        const onLoad = async () => {
            const roles = currentAccount && (currentAccount.idTokenClaims as IIdTokenClaims)['roles']
            if (roles) {
    
                let intersection = props.roles
                    .filter((role: string) => roles.includes(role));
    
                if (intersection.length > 0) {
                    setIsAuthorized(true);
                }
            }
        };
        onLoad();
    }, [props.roles, currentAccount]);

    if (!currentAccount) {
        return <Navigate replace to="/" />;
    } else {

        return (
            <div>
                {isAuthorized ? (
                    <div>{props.children}</div>
                ) : null}
            </div>
        );
    }
};